module.exports = __webpack_public_path__ + "img/card-red-cros.cd3f18c7.svg";